import { combineReducers } from 'redux'

import resultados from './consultaEmpenhoCredor'
import filtro from './filtro'
import filtroAplicados from './filtroAplicados'

export default combineReducers({ resultados, filtro, filtroAplicados })
